<template>
    <FilterChips
        id-prefix="global-catalog"
        :filters="selectedFilters"
        @remove="removeSelectedFilter"
        @clear-all="clearAllSelectedFilters"
    />
</template>

<script setup>
import { computed } from 'vue';
import FilterChips from '@/components/common/FilterChips.vue';
import { useGlobalCatalogStore } from '@/stores/globalCatalogStore';
import { useOrdersPageStore } from "@/stores/orderTemplateStore";


const globalCatalogStore = useGlobalCatalogStore()
const orderTemplateStore = useOrdersPageStore();    

const removeSelectedFilter = ({ type, data }) => {
    if ( type === 'template') {
        globalCatalogStore.selectedTemplates = globalCatalogStore.selectedTemplates.filter(t => t.id !== data.id);
    } else if ( type === 'category') {
        globalCatalogStore.setIsSelectedForCategories(data, false)
    } else if ( type === 'manufacturer') {
        globalCatalogStore.selectedManufacturers = globalCatalogStore.selectedManufacturers.filter(m => m.Manufacturer !== data.Manufacturer)
    } else if ( type === 'listTypes') {
        globalCatalogStore.selectedListTypes = globalCatalogStore.selectedListTypes.filter(t => t !== data)
    } else if ( type === 'color') {
        globalCatalogStore.selectedColors = globalCatalogStore.selectedColors.filter(c => c !== data)
    } else if ( type === 'size') {
        globalCatalogStore.selectedSizes = globalCatalogStore.selectedSizes.filter(s => s !== data)
    }
}

const clearAllSelectedFilters = () => {
    globalCatalogStore.clearSelectedFilters();
    orderTemplateStore.fetchOrderTemplateDetails();
}

const selectedFilters = computed(() => {
    let filters = [];
    if(globalCatalogStore.selectedTemplates?.length) {
        globalCatalogStore.selectedTemplates?.forEach(template => {
            filters.push({
                title: template.title,
                type: 'template',
                data: template
            })
        })
    }
    if(globalCatalogStore.selectedCategories?.length) {
        globalCatalogStore.selectedCategories?.forEach(category => {
            filters.push({
                title: category.CategoryName,
                type: 'category',
                data: category
            })
        })
    }
    if(globalCatalogStore.selectedManufacturers?.length) {
        globalCatalogStore.selectedManufacturers?.forEach(m => {
            filters.push({
                title: m.Manufacturer,
                type: 'manufacturer',
                data: m
            })
        })
    }
    if(globalCatalogStore.selectedListTypes?.length) {
        globalCatalogStore.selectedListTypes.forEach(type => {
            filters.push({
                title: type,
                type: 'listTypes',
                data: type
            })
        })
    }
    if(globalCatalogStore.selectedColors?.length) {
        globalCatalogStore.selectedColors.forEach(color => {
            filters.push({
                title: color,
                type: 'color',
                data: color
            })
        })
    }
    if(globalCatalogStore.selectedSizes?.length) {
        globalCatalogStore.selectedSizes.forEach(size => {
            filters.push({
                title: size,
                type: 'size',
                data: size
            })
        })
    }
    return filters;
})
</script>